// extracted by mini-css-extract-plugin
module.exports = {"logoImg":"QrOwQgQW","condensed":"_G3QDHFC","disabled":"Y7H0sdxh","logoFallback":"fcOg8YYo"};